import { styled } from "@mui/material";

export const StepsList = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  marginTop: theme.spacing(6),
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
}))

export const StepItem = styled('li')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}))

export const StepMedia = styled('div')(({ theme }) => ({
  width: '100%',
  borderRadius: theme.shape.borderRadius * 2,
  overflow: 'hidden',
  backgroundColor: theme.palette.grey[100],
}))

export const StepImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
})

export const LocationsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}))
